import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getExamRequestReports} from '../../services/getExamRequestReports';

export const useGetExamRequestReportsQuery = (nuPedido: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.EXAM_REQUEST_REPORTS, nuPedido],
		queryFn: ({signal}) => getExamRequestReports({nuPedido, signal}),
		enabled: !!nuPedido,
	});
